<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "User Profile",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Profile",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Users",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "activity",
          sortable: true,
          label: "Activity",
        },
        {
          key: "created_at",
          sortable: true,
          label: "Date",
        },
      ],
      modeName: "",
      data: {
        from: "",
        to: moment(new Date()).format("YYYY-MM-DD"),
      },
      editdata: {
        name: "",
        email: "",
        phone: "",
        username: "",
      },
      pass: {
        old: "",
        new: "",
        confirm: "",
      },
      passError: "",
    };
  },
  computed: {
    ...mapGetters("auth", ["getCurrentUser","Audits","resetStatus"]),
    /**
     * Total no. of records
     */

    rows() {
      return this.Audits ? this.Audits.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Audits ? this.Audits.length : 1;
    this.setData();
  },
  methods: {
    ...mapActions({
      FetchAudits: "auth/fetchAudits",
      ChangePassword: "auth/changePassword",
      EditUser: "auth/editUser",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    setData(){
        this.editdata.name = this.getCurrentUser.user.name;
        this.editdata.email = this.getCurrentUser.user.email;
        this.editdata.phone = this.getCurrentUser.user.phone;
        this.editdata.username = this.getCurrentUser.user.username;
        this.editdata.role = this.getCurrentUser.user.role;
    },

    editDetails() {
      this.EditUser(this.editdata);
    },
    changePass() {
        if(this.pass.new==this.pass.confirm){
            this.passError = "";
            this.ChangePassword(this.pass);
        }else{
            this.passError = "The two passwords do not match";
            return;
        }
    },
    filterAudits(){
        this.FetchAudits(this.data);
    }
  },
  created() {
    this.FetchAudits(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_payments')
        )
      "
    >
      <div class="col-md-3">
        <div class="card">
          <div class="card-body">
            <div class="mt-card-avatar mt-overlay-1 mb-5">
              <img src="@/assets/images/am1.png"
                alt
                class="img-fluid"
                style="border-radius: 70%"
              />
            </div>
            <h5>
              Name: <b>{{ getCurrentUser?getCurrentUser.user.name:"---" }}</b>
            </h5>
            <h6>
              Role: <b>Admin</b>
            </h6>
          </div>
        </div>
      </div>
      <div class="col-md-9">

        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-9">
                </div>
                <div class="col-md-3" align="right">
                  <b-button
                    @click="$router.go(-1)"
                    variant="primary"
                    class="btn-sm"
                    ><i class="fa fa-undo"></i> Back</b-button
                  >
                </div>
              </div>
              <!-- Tabs staart  -->
        <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Edit Details</span>
                </template>
                <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                        <form @submit.prevent="editDetails()">
                            <div class="form-group mb-2 mt-3">
                                <label>Full Name</label>
                                <input type="text" class="form-control" required v-model="editdata.name">
                            </div>
                            <div class="form-group mb-2">
                                <label>Username</label>
                                <input type="text" class="form-control" required v-model="editdata.username">
                            </div>
                            <div class="form-group mb-2">
                                <label>Phone Number</label>
                                <input type="number" class="form-control" required v-model="editdata.phone">
                            </div>
                            <div class="form-group mb-3">
                                <label>Email Address</label>
                                <input type="email" class="form-control" v-model="editdata.email">
                            </div>

                            <div class="form-group mb-2" align="center">
                                <button type="submit" class="btn btn-success"><i class="fa fa-check"></i> Save Changes</button>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3"></div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Change Password</span>
                </template>
                <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                        <form @submit.prevent="changePass()">
                            <div class="form-group mb-2 mt-3">
                                <label>Old Password</label>
                                <input type="password" class="form-control" required v-model="pass.old">
                            </div>
                            <div class="form-group mb-2 mt-3">
                                <label>New Password</label>
                                <input type="password" class="form-control" required v-model="pass.new">
                            </div>
                            <div class="form-group mb-2">
                                <label>Confirm Password</label>
                                <input type="password" class="form-control" required v-model="pass.confirm">
                            </div>

                            <div class="form-group mb-2" align="center">
                                <button type="submit" class="btn btn-success"><i class="fa fa-check"></i> Change Password</button>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3"></div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-envelope"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Audit Trails</span>
                </template>
                <div class="row">
                    <div class="col-md-4">
                        <label>From</label>
                        <input type="date" class="form-control" v-model="data.from">
                    </div>
                    <div class="col-md-4">
                        <label>To</label>
                        <input type="date" class="form-control" v-model="data.to">
                    </div>
                    <div class="col-md-4"><br>
                        <button type="submit" class="btn btn-primary" @click="filterAudits()"><i class="fa fa-search"></i> Search
                        <b-spinner
                        v-if="resetStatus"
                        variant="light"
                        small
                        label="Spinning"
                        ></b-spinner>
                        </button>
                    </div>
                </div>
                <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  class="datatables"
                  :items="Audits?Audits:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
              </b-tab>
            </b-tabs>
            <!-- Tabs end  -->
            </div>
          </div>
        </div>
      </div>
     
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
 
